export const GENERAL_LIABILITY_DESCRIPTION =
  "Automatically verify that your contractors carry sufficient General Liability insurance. Our AI extracts key policy details to confirm coverage for third-party property damage and bodily injury, reducing your project risk.";
export const GENERAL_LIABILITY_EXAMPLE_USE_CASES =
  "Protection from third-party claims of property damage, bodily injury, and advertising injury.";
export const GENERAL_LIABILITY_COST = "$15 per verification";

export const GENERAL_LIABILITY = {
  description: GENERAL_LIABILITY_DESCRIPTION,
  exampleUseCases: GENERAL_LIABILITY_EXAMPLE_USE_CASES,
  cost: GENERAL_LIABILITY_COST
};
